var map = {
	"./assets/clickable/instagram.svg": "92c214038515ed70a4f4",
	"./assets/disabled/instagram.svg": "fa5c9c7c0f8c313fc7d2",
	"./assets/original/instagram.svg": "a729327f91cfe32f00ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1399f28134eec101f569";